import React from 'react';

import { withErrorBoundary } from '../../hoc/withErrorBoundary';
import { AuthenticatedRoutes } from '../AuthenticatedRoutes/AuthenticatedRoutes';
export const PleriRenderWindow = withErrorBoundary(
  React.lazy(() =>
    import('../../micro-frontends/components/PleriRenderWindow').then(
      (module) => ({
        default: module.PleriRenderWindow,
      }),
    ),
  ),
  () => <AuthenticatedRoutes awsRumInstance={null} />,
);

export const PleriTriggerButton = withErrorBoundary(
  React.lazy(() =>
    import('../../micro-frontends/components/PleriRenderWindow').then(
      (module) => ({
        default: module.PleriTriggerButton,
      }),
    ),
  ),
);
